import { styled } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
import { mapIconContainerSizes, mapSizes } from "./constants.js";
const StyledSegmentedControl = styled("div")(() => ({
  display: "flex",
  flexDirection: "row"
})), StyledIconContainer = styled("div")(({ size = "md" }) => {
  const iconContainerSize = mapIconContainerSizes[size];
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: iconContainerSize,
    height: iconContainerSize,
    svg: {
      width: size === "sm" || size === "xs" ? "13px" : "17px",
      height: size === "sm" || size === "xs" ? "14px" : "18px"
    }
  };
}), StyledButton = styled(
  "button",
  shouldNotForwardProps([
    "color",
    "isActive",
    "isIcon",
    "variant",
    "size",
    "isPrevActive"
  ])
)(({
  theme,
  color = "primary",
  isActive,
  isIcon,
  variant = "solid",
  size = "md",
  isPrevActive
}) => {
  const palette = theme.palette[color], sizes = mapSizes[size];
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ${theme.palette.grey[400]}`,
    color: theme.palette.grey[800],
    backgroundColor: theme.palette.white.main,
    height: sizes == null ? void 0 : sizes.height,
    padding: sizes == null ? void 0 : sizes.padding,
    ...isIcon && {
      width: sizes == null ? void 0 : sizes.width,
      padding: 0
    },
    ...isActive && {
      color: palette[900],
      border: `2px solid ${palette[900]}`,
      ...variant === "solid" && {
        backgroundColor: palette[900],
        color: theme.palette.white.main
      }
    },
    "&:first-of-type": {
      borderTopLeftRadius: "2px",
      borderBottomLeftRadius: "2px"
    },
    "&:last-of-type": {
      borderTopRightRadius: "2px",
      borderBottomRightRadius: "2px"
    },
    "&:not(:last-child)": {
      borderRight: "none",
      "&:hover": {
        borderRight: !isPrevActive && !isActive && `1px solid ${theme.palette.grey[500]}`,
        "& + *:not(.active)": {
          borderLeft: "none"
        }
      },
      ...isActive && {
        borderRight: `2px solid ${palette[900]}`,
        "& + *": {
          borderLeft: "none"
        }
      }
    },
    "@media(hover:hover)": {
      "&:hover": {
        cursor: "pointer",
        borderColor: theme.palette.grey[500],
        color: palette[700],
        ...isActive && {
          color: palette[800],
          border: `2px solid ${palette[800]}`,
          ...variant === "solid" && {
            backgroundColor: palette[800],
            color: theme.palette.white.main
          }
        }
      }
    },
    "&:disabled": {
      cursor: "default",
      pointerEvents: "none",
      borderColor: theme.palette.grey[400],
      color: theme.palette.grey[500],
      backgroundColor: theme.palette.grey[200],
      ...isActive && {
        border: `2px solid  ${theme.palette.grey[400]}`,
        ...variant === "solid" && {
          backgroundColor: theme.palette.grey[400]
        }
      }
    }
  };
});
export {
  StyledButton,
  StyledIconContainer,
  StyledSegmentedControl
};
//# sourceMappingURL=styles.js.map
